const styles = new Map<string, StyleInfo>();

interface StyleInfo {
  minFontSize: number;
  maxFontSize: number;
  lineHeightFactor: number;
  fontWeight: string;
  fontFamily: string;
  letterSpacing: number;
}

// line-height and letter-spacing must be defined in a font-size relative unit!
export function getStyleInfo(elem: SVGElement | HTMLElement): StyleInfo {
  const className = elem.classList.value;
  let measure = styles.get(className);
  if (!measure) {
    const style = window.getComputedStyle(elem);
    const originalFontSize = elem.style.fontSize;
    elem.style.fontSize = "1px";
    const minFontSize = parseFloat(style.fontSize);
    elem.style.fontSize = "10000px";
    const maxFontSize = parseFloat(style.fontSize);
    elem.style.fontSize = originalFontSize;
    const fontSize = parseFloat(style.fontSize);
    measure = {
      minFontSize,
      maxFontSize,
      fontWeight: style.fontWeight,
      fontFamily: style.fontFamily,
      lineHeightFactor:
        style.lineHeight === "normal" ? 1.2 : parseFloat(style.lineHeight) / fontSize,
      letterSpacing:
        style.letterSpacing === "normal" ? 0 : parseFloat(style.letterSpacing) / fontSize,
    };
    styles.set(className, measure);
  }
  return measure;
}

export function clearStyles() {
  styles.clear();
}
